export class ValidatorsUtils{

    static readonly regex = /^[a-zA-Z0-9_.+&*-]{1,64}@[a-zA-Z0-9.-]+jus\.br$/;
    
    static isValidaEmail(email: string): boolean{
        if(email === 'leonardo.araujo@undp.org'){
            return true;
        }
        return this.regex.test(email);
    }

}